import { useEffect, useState } from "react";

type Props = {
  storageKey: string;
  queryParamKey: string;
};

export function usePersist({ storageKey, queryParamKey }: Props) {
  const [value, setValue] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === "undefined" || document === undefined) {
      return;
    }

    const params = new URLSearchParams(document.location.search);

    if (params.get(queryParamKey) === "true") {
      window.localStorage.setItem(storageKey, "true");
      setValue(true);
      return;
    }

    if (params.get(queryParamKey) === "false") {
      window.localStorage.setItem(storageKey, "false");
      setValue(false);
      return;
    }

    if (window.localStorage.getItem(storageKey) === "true") {
      setValue(true);
      return;
    }
  }, [storageKey, queryParamKey]);

  return value;
}
